/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeTriangleUpIcon20Solid = forwardRef('ShapeTriangleUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M18.549 13.156C19.609 14.82 18.415 17 16.44 17H3.559c-1.974 0-3.169-2.18-2.108-3.844l6.441-10.1c.983-1.542 3.233-1.542 4.216 0l6.44 10.1Z" })));
});
